// extracted by mini-css-extract-plugin
export default {"container":"ProtectedResponsiveImage_container__lZ8tx","image":"ProtectedResponsiveImage_image__V8nnd","protection":"ProtectedResponsiveImage_protection__twsQ4"};